var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSqs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 309,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 309",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m255.991 100.211-4.112-.069-123.792-36.65-.074-1.696v-61.796l127.987 64.006z",
    fill: "#d9a741"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m128 65.5.013-65.5-127.996 63.981-.017 181.015.064.032v.002l127.923 63.973.425-.591-.165-60.871-.251-.339-7.996-5.702-99-29.5.5-114.5z",
    fill: "#876929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m147.141 195.298-130.79 18.399.009-118.417 130.79 18.424z",
    fill: "#d9a741"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m80.864 187.813 47.132 6 .008-78.658-47.131 5.995z",
    fill: "#876929"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m33.385 181.771 30.587 3.888.009-62.363-30.596 3.897z",
    fill: "#876929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16.36 95.28 111.653-33.484 127.978 38.415-108.76 13.502z",
    fill: "#624a1e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m255.927 177.376-127.931 16.145.008-78.366 127.923 16.296z",
    fill: "#d9a741"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m255.918 208.834-2.753.119-124.776 37.77-.393.479-.009 61.801 127.931-63.951z",
    fill: "#d9a741"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m16.351 213.697 111.645 33.505 127.922-38.368-108.777-13.536z",
    fill: "#fad791"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqs);
export default __webpack_public_path__ + "static/media/sqs.98ff30dc390ada01ac644dfbe6073287.svg";
export { ForwardRef as ReactComponent };